'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdNaturePeople = function MdNaturePeople(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm7.5 18.4c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5z m29.5-3.1c0 6-4.6 10.9-10.4 11.6v6.5h5v3.2h-26.6v-8.2h-1.6v-6.8c0-0.9 0.7-1.6 1.6-1.6h5c0.9 0 1.6 0.7 1.6 1.6v6.8h-1.6v5h13.4v-6.6c-5.6-0.9-9.8-5.7-9.8-11.5 0-6.5 5.2-11.7 11.7-11.7s11.7 5.2 11.7 11.7z' })
        )
    );
};

exports.default = MdNaturePeople;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/nature-people.js
// module id = 3093
// module chunks = 0